import { useDarkModeToggle } from '../hooks/useDarkModeToggle'

import { Box, FormControl, FormLabel, Switch } from '@chakra-ui/react'

import { Card } from '@/components/ui'

export const DarkModeSetting = () => {
  const { isDarkMode, toggleDarkMode } = useDarkModeToggle()

  const handleToggle = () => {
    toggleDarkMode()
  }

  return (
    <Card
      _hover={{
        boxShadow: '0px 2px 5px 6px rgba(0, 0, 0, 0.15)',
      }}
      p='0'
      transition='ease-in-out'
      transitionDuration='300ms'
      transitionProperty='all'
    >
      <Box fontSize='20px' fontWeight='extrabold' letterSpacing='-0.6px' p='4'>
        Display Settings
      </Box>

      <Box
        bgColor='#F0F5FD'
        borderBottom='1px solid #eaedf3'
        borderTop='1px solid #eaedf3'
        p='4'
      >
        <FormControl alignItems='center' display='flex'>
          <FormLabel htmlFor='dark-mode-toggle' mb='0'>
            Enable Dark Mode
          </FormLabel>
          <Switch
            id='dark-mode-toggle'
            isChecked={isDarkMode}
            onChange={handleToggle}
          />
        </FormControl>
      </Box>
    </Card>
  )
}
